
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Plotly } from 'vue-plotly';

@Component({
  components: { Plotly },
})
export default class GaugeCard extends Vue {
  @Prop() readonly gaugeText!: { title: string; learnText: string };
  @Prop() readonly link!: string;
  @Prop() readonly chartValue!: number;

  get gaugeData() {
    const value = 180 * this.chartValue;
    const degrees = 180 - value;
    const radians = (degrees * Math.PI) / 180;

    const radius = 0.5;

    const x = radius * Math.cos(radians);
    const y = radius * Math.sin(radians);
    const mainPath = 'M -.001 -0.01 L .001 0.01 L ';
    const pathX = String(x);
    const space = ' ';
    const pathY = String(y);
    const pathEnd = ' Z';
    const path = mainPath.concat(pathX, space, pathY, pathEnd);

    const data = [
      {
        type: 'scatter',
        x: [0],
        y: [0],
        marker: { size: 12, color: 'black' },
        showlegend: false,
        name: 'risk',
      },
      {
        values: [50 / 6, 50 / 6, 50 / 6, 50 / 6, 50 / 6, 50 / 6, 50],
        rotation: 90,

        textinfo: 'text',
        textposition: 'inside',
        marker: {
          colors: [
            '#EA6076',
            '#F17A64',
            '#F68E55',
            '#E1B145',
            '#8EB75B',
            '#39BE71',
            'rgba(255, 255, 255, 0)',
          ],
        },

        hole: 0.5,
        type: 'pie',
        showlegend: false,
      },
    ];

    const layout = {
      shapes: [
        {
          type: 'path',
          path: path,
          fillcolor: 'black',

          line: {
            color: 'black',
          },
        },
      ],
      hovermode: false,
      height: 220,
      width: 224,
      margin: {
        l: 10,
        r: 10,
        b: 10,
        t: 10,
        pad: 0,
      },
      xaxis: {
        fixedrange: true,
        type: 'category',
        zeroline: false,
        showticklabels: false,
        showgrid: false,
        range: [-1, 1],
      },
      yaxis: {
        fixedrange: true,
        type: 'category',
        zeroline: false,
        showticklabels: false,
        showgrid: false,
        range: [-1, 1],
      },
      paper_bgcolor: 'transparent',
      plot_bgcolor: 'transparent',
    };

    return {
      data,
      layout,
    };
  }
}
